import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '@base/material';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import * as fromParameter from '@parameter/store/parameter.reducer';
import { ParameterEffects } from '@parameter/store/parameter.effects';
import { ParameterComponent } from '@parameter/parameter.component';
import { ParameterService } from '@parameter/parameter.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    StoreModule.forFeature(fromParameter.parameterFeatureKey, fromParameter.reducer),
    EffectsModule.forFeature([ParameterEffects]),
    FontAwesomeModule,
  ],
  declarations: [ParameterComponent, ],
  exports: [ParameterComponent, ],
  providers: [ParameterService, ]
})
export class ParameterModule { }
